var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',[_c('div',{staticClass:"loadingComponent"},[_c('Loading',{attrs:{"color":"#1989fa"}})],1),_c('div',{staticClass:"bg"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }